var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pagination-controls',{attrs:{"show":_vm.show,"text":_vm.text,"can-prev":_vm.canPrev,"can-next":_vm.canNext},on:{"prev":function($event){return _vm.$emit('prev')},"next":function($event){return _vm.$emit('next')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }